export default __webpack_public_path__ + "static/services-header-7592c6d6b7d49fb021f7ee3f37dad6da.jpg";